import * as actionType from "../actionType";

/** Max customer keys kept per map to avoid unbounded Redux state (P1 #3). */
const MAX_CUSTOMER_KEYS = 10;

/** Keep at most maxKeys entries: currentKey plus (maxKeys-1) others by insertion order. */
function pruneByCustomerKey(obj, currentKey, maxKeys) {
  const keys = Object.keys(obj);
  if (keys.length <= maxKeys) return obj;
  const kept = [currentKey];
  for (const k of keys) {
    if (k !== currentKey && kept.length < maxKeys) kept.push(k);
  }
  const next = {};
  kept.forEach((k) => (next[k] = obj[k]));
  return next;
}

const initialState = {
  sensorList: {},
  sensorInfo: {},
};

const reducer = (state = initialState, action) => {
  let _sensorList;
  let _customerSensorList;
  switch (action.type) {
    case actionType.sensorUpdateSensorList:
      _sensorList = state.sensorList;
      _sensorList[action.data.customerId] = action.data.sensorData;
      _sensorList = pruneByCustomerKey(_sensorList, action.data.customerId, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        sensorList: {
          ..._sensorList,
        },
      };
    case actionType.sensorUpdateSensorInfo:
      let _sensorInfo = state.sensorInfo;
      _sensorInfo[action.data.customerId] = { ...action.data.sensorInfo };
      _sensorInfo = pruneByCustomerKey(_sensorInfo, action.data.customerId, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        sensorInfo: {
          ..._sensorInfo,
        },
      };
    case actionType.sensorAddNewSensor:
      _sensorList = state.sensorList;
      _sensorList[action.data.customerId] = [
        ..._sensorList[action.data.customerId],
        action.data.sensorInfo,
      ];
      _sensorList = pruneByCustomerKey(_sensorList, action.data.customerId, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        sensorList: {
          ..._sensorList,
        },
      };
    case actionType.sensorUpdateSensor:
      _sensorList = state.sensorList;

      _customerSensorList = _sensorList[action.data.customerId];
      try {
        let _selectedSensor = _customerSensorList.filter(
          (x) => x.sensor_id === action.data.sensorInfo.sensor_id
        )[0];
        _selectedSensor = { ...action.data.sensorInfo };

        _customerSensorList = [
          ..._customerSensorList.filter(
            (x) => x.sensor_id !== action.data.sensorInfo.sensor_id
          ),
          { ..._selectedSensor },
        ];

        _sensorList[action.data.customerId] = [..._customerSensorList];
        _sensorList = pruneByCustomerKey(_sensorList, action.data.customerId, MAX_CUSTOMER_KEYS);

        return {
          ...state,
          sensorList: {
            ..._sensorList,
          },
        };
      } catch (err) {}
      break;
    case actionType.sensorDeleteSensor:
      _sensorList = state.sensorList;
      _customerSensorList = _sensorList[action.data.customerId];
      try {
        _customerSensorList = [
          ..._customerSensorList.filter(
            (x) => x.sensor_id !== action.data.sensorId
          ),
        ];

        _sensorList[action.data.customerId] = [..._customerSensorList];
        _sensorList = pruneByCustomerKey(_sensorList, action.data.customerId, MAX_CUSTOMER_KEYS);

        return {
          ...state,
          sensorList: {
            ..._sensorList,
          },
        };
      } catch (err) {}
      break;
    default:
      return state;
  }
};

export default reducer;


